function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ClientDetail, { ColorHeader } from "../../../clients/form/ClientDetail";
import { ClientType } from "../../../ISchema";
import defaultClient from "../../../clients/defaultClient";
import PolizaCover from "./PolizaCover";

var ProposedCover = function ProposedCover(props) {
  var poliza = props.poliza,
      onChange = props.onChange,
      _props$regions = props.regions,
      regions = _props$regions === void 0 ? [] : _props$regions,
      _props$comunas = props.comunas,
      comunas = _props$comunas === void 0 ? [] : _props$comunas,
      token = props.token,
      additional_files = props.additional_files,
      document = props.document,
      assist_card = props.assist_card;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      aseguradoHasCopied = _React$useState2[0],
      setAsegudadoHasCopied = _React$useState2[1];

  var _React$useState3 = React.useState(true),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      beneficiarioHasCopied = _React$useState4[0],
      setBeneficiarioHasCopied = _React$useState4[1];

  var _React$useState5 = React.useState("contratante"),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      currentType = _React$useState6[0],
      setCurrentType = _React$useState6[1];

  var checkIsClientHasCopied = function checkIsClientHasCopied() {
    var asegurado = poliza.asegurado,
        contratante = poliza.contratante,
        beneficiario = poliza.beneficiario;

    if (!contratante.id) {
      setAsegudadoHasCopied(true);
      setBeneficiarioHasCopied(true);
      return;
    }

    if (!asegurado.id || asegurado.id != contratante.id) setAsegudadoHasCopied(false);
    if (!beneficiario.id || beneficiario.id != contratante.id) setBeneficiarioHasCopied(false);
  };

  var onChangeSomeClient = function onChangeSomeClient(newClient, clientType) {
    if (clientType === ClientType.contratante) {
      var mainEmail = _objectSpread({}, getMainEmailClient(poliza.contratante));

      var asegurado = aseguradoHasCopied ? _objectSpread(_objectSpread(_objectSpread({}, poliza.asegurado), newClient), {}, {
        emails: [mainEmail]
      }) : _objectSpread({}, poliza.asegurado);
      var beneficiario = beneficiarioHasCopied ? _objectSpread(_objectSpread(_objectSpread({}, poliza.beneficiario), newClient), {}, {
        emails: [mainEmail]
      }) : _objectSpread({}, poliza.beneficiario);
      return onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        contratante: _objectSpread(_objectSpread({}, poliza.contratante), newClient),
        asegurado: _objectSpread(_objectSpread({}, poliza.asegurado), asegurado),
        beneficiario: _objectSpread(_objectSpread({}, poliza.beneficiario), beneficiario)
      }));
    }

    if (clientType === ClientType.asegurado) {
      return onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        asegurado: _objectSpread(_objectSpread({}, poliza.asegurado), newClient)
      }));
    }

    if (clientType === ClientType.beneficiario) {
      return onChange(_objectSpread(_objectSpread({}, poliza), {}, {
        beneficiario: _objectSpread(_objectSpread({}, poliza.beneficiario), newClient)
      }));
    }
  };

  var onChangePolizaCover = function onChangePolizaCover(polizaCover) {
    return onChange(_objectSpread(_objectSpread({}, poliza), polizaCover));
  };

  React.useEffect(function () {
    checkIsClientHasCopied();
  }, []);

  var getMainEmailClient = function getMainEmailClient(client) {
    return client.emails.find(function (email) {
      return email.is_main;
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row proposedCover"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/React.createElement(PolizaCover, {
    additional_files: additional_files,
    poliza: poliza,
    onChange: onChangePolizaCover,
    document: document,
    assist_card: assist_card,
    token: token
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 client"
  }, currentType === "contratante" && /*#__PURE__*/React.createElement(ClientDetail, {
    title: "Contratante",
    onChangeCurrentType: function onChangeCurrentType(newCurrentType) {
      return setCurrentType(newCurrentType);
    },
    currentType: currentType,
    token: token,
    colorHeader: ColorHeader.Gray,
    user: poliza.contratante,
    listRegions: regions,
    listComunas: comunas,
    onChange: function onChange(newClient) {
      return onChangeSomeClient(newClient, ClientType.contratante);
    }
  }), currentType === "asegurado" && /*#__PURE__*/React.createElement(ClientDetail, {
    title: "Asegurado",
    onChangeCurrentType: function onChangeCurrentType(newCurrentType) {
      return setCurrentType(newCurrentType);
    },
    currentType: currentType,
    token: token,
    colorHeader: ColorHeader.Gray,
    useCopyMode: true,
    hasCopyFromOtherClient: aseguradoHasCopied,
    onChangeCheckCopy: function onChangeCheckCopy() {
      var newAseguradoHasCopied = !aseguradoHasCopied;
      if (newAseguradoHasCopied) onChangeSomeClient(poliza.contratante, ClientType.asegurado);else onChangeSomeClient(defaultClient, ClientType.asegurado);
      setAsegudadoHasCopied(!aseguradoHasCopied);
    },
    listRegions: regions,
    listComunas: comunas,
    onChange: function onChange(newClient) {
      return onChangeSomeClient(newClient, ClientType.asegurado);
    },
    user: poliza.asegurado
  }), currentType === "beneficiario" && /*#__PURE__*/React.createElement(ClientDetail, {
    title: "Beneficiario",
    onChangeCurrentType: function onChangeCurrentType(newCurrentType) {
      return setCurrentType(newCurrentType);
    },
    currentType: currentType,
    token: token,
    colorHeader: ColorHeader.Gray,
    useCopyMode: true,
    hasCopyFromOtherClient: beneficiarioHasCopied,
    listRegions: regions,
    listComunas: comunas,
    onChange: function onChange(newClient) {
      return onChangeSomeClient(newClient, ClientType.beneficiario);
    },
    onChangeCheckCopy: function onChangeCheckCopy() {
      var newBeneficiarioHasCopied = !beneficiarioHasCopied;
      if (newBeneficiarioHasCopied) onChangeSomeClient(poliza.contratante, ClientType.beneficiario);else onChangeSomeClient(defaultClient, ClientType.beneficiario);
      setBeneficiarioHasCopied(!beneficiarioHasCopied);
    },
    user: poliza.beneficiario
  })));
};

export default ProposedCover;